(() => {
  const barbecueGrassModalButton = '.barbecue-grass-modal-button';
  const barbecueLoofModalButton = '.barbecue-loof-modal-button';
  const barbecueAreaImage = '.js-barbecue-area-img';

  const init = () => {
    $('body')
      .on('click', barbecueGrassModalButton, showBarbecueGrassModal)
      .on('click', barbecueLoofModalButton, showBarbecueLoofModal)
      .on('click', barbecueAreaImage, showSelectedBarbecueAreaImage);
  }

  const showSelectedBarbecueAreaImage = e => {
    e.preventDefault();
    const $img = $(e.currentTarget);
    $('.js-slide-target').attr('src', $img.attr('src'));
  }

  const showBarbecueGrassModal = e => {
    e.preventDefault();
    const barbecueAreas = $('#data-barbecue-area').data('barbecue-area');
    const barbecueAreaImages = $('#data-barbecue-area-image').data('barbecue-area-image');
    grassArea = barbecueAreas[0];
    var targetBarbecueAreaImages = barbecueAreaImages.filter(image => image.barbecue_area_id == grassArea.id)

    $('.barbecue-area-detail-modal').empty();
    $('.barbecue-area-detail-modal').append(buildBarbecueAreaModal(grassArea, targetBarbecueAreaImages));
  }

  const buildBarbecueAreaModal = (grassArea, images) => {
    var barbecueArea =
    `
      <div class="modal-body">
        <div class="price-block">
          <div class="block-left js-slide">
            <img src="${images[0].image.admin_show_thumb.url}" class="js-slide-target">
            <div class="camping-rental-float-images">
              ${showImage(images, 0)}
              ${showImage(images, 1)}
              ${showImage(images, 2)}
              ${showImage(images, 3)}
            </div>
          </div>
          <div class="block-right">
            <div class="title">${grassArea.area_name}</div>
            <div class="description modal-description">${grassArea.description}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success inversion btn-block" data-dismiss="modal" type="button">閉じる</button>
      </div>
    `
    return barbecueArea;
  }

  const showImage = (images, key) => {
    if (images[key] != null) {
      return `<img class="camping-rental-float-image js-barbecue-area-img" src="${images[key].image.admin_show_thumb.url}">`;
    }
    return '';
  }

  const showBarbecueLoofModal = e => {
    e.preventDefault();
    const barbecueAreas = $('#data-barbecue-area').data('barbecue-area');
    const barbecueAreaImages = $('#data-barbecue-area-image').data('barbecue-area-image');
    loofArea = barbecueAreas[1];
    var targetBarbecueAreaImages = barbecueAreaImages.filter(image => image.barbecue_area_id == loofArea.id)

    $('.barbecue-area-detail-modal').empty();
    $('.barbecue-area-detail-modal').append(buildBarbecueAreaModal(loofArea, targetBarbecueAreaImages));

  }
  $(init);
})();

